import { forwardRef } from 'react';
import { StyledSection } from './styled';

const Section = forwardRef((props, ref) => (
  <StyledSection ref={ref} {...props} />
));

export default Section;
